import React from 'react';
import './App.css';
import HaikuLine from './compontents/HaikuLine'

function App() {
  return (
    <div className="App">
    <div class="header">Haiku Writer</div>
      <HaikuLine syllable_count="5"></HaikuLine>
      <HaikuLine syllable_count="7"></HaikuLine>
      <HaikuLine syllable_count="5"></HaikuLine>
    </div>
  );
}

export default App;
